import { Helpers } from '../../helpers';
import { IWellStatus } from '../../interfaces/iwell-status';
import { SaltWaterDisposalFacility } from '../salt-water-disposal-facility';
import { Well } from '../well';

export class WellStatusBase {
  WellStatusId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  SaltWaterDisposalFacilities_WellStatus?: Array<SaltWaterDisposalFacility> | null;
  Wells_WellStatus?: Array<Well> | null;

  constructor(item?: IWellStatus) {
    if (item) {
      this.WellStatusId = item.WellStatusId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.SaltWaterDisposalFacilities_WellStatus = Helpers.createClassArray(SaltWaterDisposalFacility, item.SaltWaterDisposalFacilities_WellStatus);
      this.Wells_WellStatus = Helpers.createClassArray(Well, item.Wells_WellStatus);

    }
  }
}